import React, { useEffect, useState } from 'react'
import TextField from '../../elements/form/TextField'
import TextareaField from '../../elements/form/TextareaField'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR } from '../../../store/types'
import { createInventoryLocation } from '../../../store/actions/inventoryActions'
import TagCloud from '../../elements/form/TagCloud'
import { fetchStaff } from '../../../store/actions/staffActions'
import Loader from '../../elements/Loader'
import RadioGroup from '../../elements/form/RadioGroup'

const EditInventoryLocation = ({location, close}) => {
    const [locationPayload, setLocationPayload] = useState(location)
    const [validationErrors, setValidationErrors] = useState({})
    
    const inventorySelector = useSelector(state =>state.inventory)
    const staffSelector = useSelector(state => state.staff)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchStaff('', 0, 0))
    
        return () => {
            
        }
    }, [dispatch])
    

    const validateForm = () => {
        let errors = {}

        if(!locationPayload.name || locationPayload.name === ''){
            errors.name = true
        }

        if(!locationPayload.locationCode || locationPayload.locationCode === '') {
            errors.locationCode = true
        }

        if(!locationPayload.description || locationPayload.description === '') {
            errors.description = true
        }

        if(locationPayload.description && locationPayload.description.length > 300) {
            errors.description = true
        }

        if(!locationPayload.status || locationPayload.status === ''){
            errors.status = true
        }

        console.log(errors)
        setValidationErrors(errors)
        return errors
    }

    const pushLocation = () => {
        if(Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
        const payload = {
            ...locationPayload,
            approvers: locationPayload.approvers && locationPayload.approvers.length > 0 ? locationPayload.approvers.map(appr => appr.value) : undefined
        }
        dispatch(createInventoryLocation(payload))
    }

    const locationStatuses = [
        {label: "Active", value: 'active'},
        {label: "Inactive", value: 'inactive'},
    ]

    return (
        <div className='w-full'>
            <p className="text-sm">Please provide details of the new inventory location below.</p>
            <div className='mt-4 w-full'>
                <TextField
                    inputLabel="Name" 
                    inputPlaceholder={`The location name`}
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={locationPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setLocationPayload({...locationPayload, ...{name: value}})}}
                />
            </div>

            <div className='mt-4 w-full'>
                <TextField
                    inputLabel="Location code" 
                    inputPlaceholder={`Code for easy identification`}
                    fieldId="location-code" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={locationPayload.locationCode || ''}
                    hasError={validationErrors && validationErrors.locationCode} 
                    returnFieldValue={(value)=>{setLocationPayload({...locationPayload, ...{locationCode: value}})}}
                />
            </div>

            <div className='mt-4 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="status-note" 
                    inputPlaceholder={`Describe the location (300 chars max)`}
                    inputType="text" 
                    requiredField={true}
                    preloadValue={locationPayload.description || ''}
                    hasError={validationErrors.description} 
                    maxLength={300}
                    returnFieldValue={(value)=>{setLocationPayload({...locationPayload, ...{description: value}})}}
                />
                {locationPayload?.description?.length === 300 &&<p className='text-red-600 text-xs mt-2'>Please keep the description less than 300 characters</p>}

            </div>

            <div className='mt-4 w-full'>
                <RadioGroup 
                    items={locationStatuses} 
                    inline={true}
                    preSelectedIndex={locationStatuses.findIndex(item => item.value === locationPayload.status)}
                    inputLabel={'Location Status'}
                    requiredField={true}
                    returnSelected={(value) => {setLocationPayload({...locationPayload, ...{status: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            <div className='mt-4 w-full pb-3 border-b border-gray-300'>
                <h3 className='font-space-grotesk font-[550] mb-1 text-[15px] text-gray-800'>Approvers</h3>
                <p className="text-sm text-gray-600">Approvers are the staff responsible for approving or rejecting requests for any items in this location. 
                    <br />
                    You can select multiple approvers
                </p>
            </div>

            {staffSelector.loadingStaff ? 
                <Loader />
            : <>
                {staffSelector?.staffMembers?.staff?.length > 0 && <div className='my-2 w-full'>
                    <TagCloud 
                        inputLabel="Select Approvers"
                        inputPlaceholder = 'Type and press Enter...'
                        tags={staffSelector.staffMembers.staff.map(staff => {
                            return {
                                label: staff.fullName,
                                value: staff._id
                            }
                        })}
                        preselected={locationPayload?.approvers?.map(staff => {
                            return {
                                label: staff.fullName,
                                value: staff._id
                            }
                        }) || []}
                        hasError={false}
                        position='top'
                        // position=
                        helperText={'Search and select approving staff using this field'}
                        returnFieldValue={(value)=>{setLocationPayload({...locationPayload, ...{approvers: value}})}}
                    />
                </div>}
            </>}


            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create new inventory location`}
                    buttonAction={()=>{pushLocation()}}
                    processing={inventorySelector.creatingLocations}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditInventoryLocation